import {Component, HostBinding, OnInit} from '@angular/core';
import {WebLessonNotification, WebLessonNotificationService} from "./WebLessonNotification.service";
import {faXmark} from "@fortawesome/pro-regular-svg-icons";
import {WebLessonService} from "src/app/coreModule/lessonModule/WebLessonModule/services/WebLesson.service";

@Component({
	selector: 'web-lesson-notification',
	template: `
		<div class="counter">{{ web_lesson_notification.total_count }}</div>
		<div class="notification-list">
			<div class="notification" *ngFor="let notification of web_lesson_notification.notification_list; trackBy: trackById" [ngClass]="[notification.color]">
				<div class="icon">
					<fa-icon [icon]="notification.icon"></fa-icon>
				</div>
				<div class="message">{{ notification.message }}</div>
				<fa-icon [icon]="faXmark" class="btn-close" (click)="close_notification(notification)"></fa-icon>
			</div>
		</div>
	`,
	styleUrls: ['./web-lesson-notification.component.scss']
})

export class WebLessonNotificationComponent implements OnInit {

	public faXmark = faXmark;

	public timer = new Map();

	@HostBinding('style.display')
	get style_display() {
		if (!this.web_lesson_notification.show) {
			return 'none';
		}

		return null;
	}

	constructor(
		public web_lesson_notification: WebLessonNotificationService
	) {
		setInterval(() => {
			if (this.web_lesson_notification.notification_list.length === 0) {
				return;
			}
			let now = Date.now();
			this.web_lesson_notification.notification_list.forEach((notification: WebLessonNotification) => {
				if (!this.timer.has(notification)) {
					this.on_show(notification);
				}
				if (this.timer.get(notification) < now) {
					this.on_close(notification);
				}
			})
		}, 100);

		window['web_lesson_notification'] = this.web_lesson_notification;
	}

	ngOnInit() {
		// let count = 0;
		// setInterval(() => {
		// 	this.web_lesson_notification.add({
		// 		message: "Test " + count,
		// 		duration_ms: 2000,
		// 		on_show: () => {
		// 			console.log('web lesson notification on show')
		// 		},
		// 		on_close: () => {
		// 			console.log('web lesson notification on close')
		// 		}
		// 	});
		// 	count++;
		// }, 1000)
	}

	@HostBinding('class.hide')
	get class_hide() {
		return this.web_lesson_notification.total_count == 0;
	}

	on_show(notification: WebLessonNotification) {
		this.timer.set(notification, Date.now() + notification.duration_ms);
		if (notification.on_show) {
			notification.on_show()
		}
	}

	on_close(notification: WebLessonNotification) {
		this.web_lesson_notification.remove(notification);
		this.timer.delete(notification);
		if (notification.on_close) {
			notification.on_close();
		}
	}

	close_notification(notification) {
		this.on_close(notification);
	}

	trackById(notification) {
		return notification.id;
	}
}